import {mapTechnology} from './normalizeTechnologies';

export default (response) => response?.data?.map(mapTechnology)?.[0] ?? {};
